import React from 'react';
import { string, bool, number } from 'prop-types';
import { SchemaBuilder } from '../core/SchemaBuilder';

const DynamicRecs = ({
  anchor,
  anchorImage,
  hideFavorites,
  maxItems,
  requestKey,
  schemaName,
  showLoading,
  hideFulfillment,
  collectionUrl
}) => {
  return (
    <div id={schemaName}>
      <meta data-prop="name" content={schemaName} />
      <SchemaBuilder
        anchor={anchor}
        anchorImage={anchorImage}
        hideFavorites={hideFavorites}
        hideFulfillment={hideFulfillment}
        maxItems={maxItems}
        requestKey={requestKey}
        showLoading={showLoading}
        collectionUrl={collectionUrl}
        schemaName={schemaName}
      />
    </div>
  );
};

DynamicRecs.propTypes = {
  anchor: string.isRequired,
  anchorImage: string,
  collectionUrl: string,
  hideFavorites: bool,
  hideFulfillment: bool,
  maxItems: number,
  requestKey: string.isRequired,
  schemaName: string.isRequired,
  showLoading: bool
};

DynamicRecs.defaultProps = {
  anchorImage: null,
  collectionUrl: null,
  hideFulfillment: false,
  hideFavorites: true,
  maxItems: 16,
  showLoading: false
};

export { DynamicRecs };
